<script>

import CommonSubtitle from "../../CommonSubtitle/index.vue";
import CustomTextField from "../../CustomInput/CustomTextField.vue";
import CustomTextDropdown from "../../CustomInput/CustomDropdown.vue";
import {Cities} from "../../../utils/constants";
import {BankIcons} from "../../../constants";
import CustomSelect from "../../global/CustomSelect/index.vue";
import {mapState} from "vuex";

export default {
  name: "BankAccountInfo",
  components: {CustomSelect, CustomTextDropdown, CustomTextField, CommonSubtitle},
  props: {
    bankAccountInfo: {
      type: Object,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      banks: BankIcons.map(item => ({id: item.value, label: item.name, logo: item.logo})),
    }
  },
  computed: {
    ...mapState('user', ['user', "danState", "tempUser"]),
  },
  mounted() {
    if(this.user) {
      this.bankAccountInfo.bank_name = this.user.bank_name
      this.bankAccountInfo.account_number = this.user.account_number
      this.bankAccountInfo.bank_account_holder = this.user.firstname ?? this.user.bank_account_holder
    }
    if(this.danState === true){
      this.bankAccountInfo.bank_account_holder = this.tempUser.firstname
    }
  },
  methods: {
    updateParent() {
      this.$emit('update', this.disabilityInfo);
    },
  }
}
</script>

<template>
  <div>
    <CommonSubtitle :name="$t('kyc.bank_account')"/>
    <div class="ml-4 mr-4">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomSelect
              :label="$t('kyc.bank_name')"
              v-model="bankAccountInfo.bank_name"
              :options="banks"
              :error="v$?.bank_name.$error"
              :error-message="$t('kyc.fill_this')"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomTextField :label="$t('kyc.bank_account_number')" v-model="bankAccountInfo.account_number"
                           type="number"
                           :error="v$?.account_number.$error"
                           :error-message="$t('kyc.fill_this')"
          />
        </div>
        <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <CustomTextField :label="$t('kyc.bank_account_holder')" v-model="bankAccountInfo.bank_account_holder"
                           :error="v$?.bank_account_holder.$error"
                           :error-message="$t('kyc.fill_this')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>